//load modules
import AjaxForm from './components/AjaxForm';
import AjaxTable from './components/AjaxTable';
import Header from './components/Header';
import Notifications from './components/Notifications/Notifications';
import PatientRequestForm from './components/PatientRequest/PatientRequestForm';
import SearchForm from './components/SearchForm.js';
import GlobalForm from './components/GlobalForm.js';
import GlobalContent from './components/GlobalContent';

import Checkbox from './components/Checkbox';
import DateField from './components/DateField';
import Radio from './components/Radio';
import NHILookup from './components/NHILookup';
import ApprovalHistoryPanel from './components/ApprovalHistoryPanel';

//components
export const components = {
    '.ajax-form': AjaxForm,
    '.ajax-table': AjaxTable,
    '.search-form': SearchForm,
    'header': Header,
    '.notifications': Notifications,
    '.patient-request-form': PatientRequestForm,
    '#ClinicianRegistrationForm_ClinicianRegistrationForm': AjaxForm,
    '.radio': Radio,
    'div.checkbox': Checkbox,
    'input.date': DateField,
    '.input-group.nhi': NHILookup,
    '.approval-history': ApprovalHistoryPanel,
    'form input': GlobalForm,
    'form select': GlobalForm,
    '.page': GlobalContent
};
